import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=567aebfd&scoped=true&lang=pug&"
import script from "./ImageField.vue?vue&type=script&lang=js&"
export * from "./ImageField.vue?vue&type=script&lang=js&"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=567aebfd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567aebfd",
  null
  
)

/* custom blocks */
import block0 from "./ImageField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports